import React from 'react';

export const generalInfoIcon = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="10%"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#616365"
      stroke="none"
    >
      <path
        d="M2315 5109 c-597 -61 -1141 -318 -1563 -739 -1002 -1000 -1002 -2620
0 -3620 407 -405 900 -647 1493 -732 119 -17 512 -16 635 1 997 138 1799 800
2111 1743 90 273 124 488 124 798 0 310 -34 525 -124 798 -308 932 -1098 1593
-2076 1738 -122 18 -477 26 -600 13z m570 -414 c606 -94 1138 -434 1475 -943
400 -602 470 -1375 187 -2036 -299 -697 -917 -1175 -1672 -1293 -149 -24 -487
-23 -634 0 -952 154 -1670 872 -1818 1822 -24 151 -24 479 0 630 96 613 429
1140 936 1479 302 202 634 319 1026 360 81 8 403 -4 500 -19z"
      />
      <path
        d="M2465 3744 c-58 -20 -106 -64 -140 -125 -26 -47 -30 -64 -30 -129 1
-90 21 -135 88 -197 131 -120 333 -81 420 82 16 30 22 58 22 115 0 65 -4 82
-30 129 -16 29 -45 66 -64 82 -68 56 -179 74 -266 43z"
      />
      <path
        d="M2496 2965 c-49 -17 -93 -59 -117 -110 -17 -38 -19 -80 -19 -726 l0
-686 23 -44 c71 -135 254 -145 342 -20 l30 43 3 691 c3 775 6 744 -68 811 -59
53 -123 67 -194 41z"
      />
    </g>
  </svg>
);

export const restOfTheWorldCostsIcon = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="10%"
    height="30"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#616365"
      stroke="none"
    >
      <path
        d="M2535 4933 c-111 -10 -273 -38 -390 -68 -838 -216 -1485 -920 -1631
-1775 -9 -52 -17 -96 -19 -98 -2 -2 -20 25 -40 59 -20 35 -44 69 -53 76 -45
34 -122 -4 -122 -60 0 -49 214 -412 252 -428 52 -21 69 -7 217 182 154 197
163 218 116 264 -45 46 -89 30 -157 -57 -27 -34 -48 -55 -48 -47 0 39 35 204
65 308 273 949 1205 1579 2186 1481 485 -49 914 -253 1260 -599 242 -242 399
-496 504 -816 238 -720 66 -1491 -458 -2063 -37 -39 -67 -81 -67 -92 0 -55 53
-99 104 -86 26 6 153 145 242 263 214 284 363 644 421 1013 24 159 24 492 -1
645 -79 493 -288 908 -631 1250 -371 371 -851 597 -1370 645 -103 9 -290 11
-380 3z"
      />
      <path
        d="M2530 4439 c-644 -65 -1211 -493 -1456 -1096 -92 -228 -128 -436
-122 -705 l3 -178 -363 0 -363 0 -24 -25 -25 -24 0 -956 0 -956 25 -24 c24
-25 25 -25 228 -25 l204 0 12 -38 c7 -21 28 -59 47 -85 170 -234 523 -174 617
106 6 16 46 17 642 17 596 0 636 -1 642 -17 32 -98 103 -180 191 -221 48 -23
71 -27 142 -27 100 0 170 27 242 94 40 36 98 132 98 160 0 7 36 11 98 11 105
1 124 8 142 54 6 17 10 142 10 320 l0 293 27 12 c119 54 354 239 470 370 298
334 455 741 454 1179 0 500 -184 933 -545 1280 -372 357 -881 533 -1396 481z
m100 -446 l0 -286 -127 6 c-131 7 -250 20 -361 38 l-63 11 37 67 c96 173 235
327 355 391 54 29 127 57 152 59 4 1 7 -128 7 -286z m237 266 c163 -60 344
-243 451 -456 l21 -41 -62 -11 c-110 -18 -229 -31 -359 -38 l-128 -6 0 286 c0
177 4 287 10 287 5 0 35 -10 67 -21z m-687 -63 c0 -3 -19 -26 -42 -53 -54 -62
-145 -201 -183 -280 -18 -37 -37 -62 -46 -62 -20 -1 -215 56 -243 71 -19 10
-18 13 19 45 114 98 342 229 493 282 1 1 2 -1 2 -3z m1248 -78 c170 -83 354
-224 480 -368 224 -254 372 -591 398 -908 l7 -82 -294 2 -294 3 -2 40 c-16
257 -51 479 -109 676 -20 68 -38 133 -41 145 -4 18 5 23 72 43 86 25 115 48
115 91 0 37 -39 80 -71 80 -12 0 -58 -10 -102 -22 -69 -19 -82 -20 -89 -8 -5
8 -31 56 -59 105 -28 50 -84 134 -125 187 l-74 98 52 -21 c29 -11 90 -38 136
-61z m-1750 -418 c83 -27 158 -50 166 -50 11 0 7 -21 -16 -92 -67 -211 -112
-458 -124 -680 l-7 -118 -118 0 c-115 0 -118 -1 -138 -26 -12 -15 -21 -37 -21
-50 0 -67 36 -84 175 -84 l105 0 0 -70 0 -70 -289 0 -290 0 -7 56 c-12 99 3
390 25 492 42 189 122 387 216 534 54 83 152 208 164 208 4 0 76 -22 159 -50z
m464 -110 c144 -23 325 -40 421 -40 l67 0 0 -395 0 -395 -385 0 -385 0 0 58
c0 85 27 299 55 439 21 105 93 353 102 353 1 0 58 -9 125 -20z m1297 -77 c66
-207 107 -430 118 -640 l6 -113 -386 0 -387 0 0 393 0 394 133 6 c130 7 348
31 417 47 67 16 66 17 99 -87z m-809 -1253 l0 -340 -55 0 -55 0 0 245 0 246
-25 24 -24 25 -306 0 -305 0 0 70 0 70 385 0 385 0 0 -340z m930 282 c0 -233
-118 -782 -169 -782 -17 0 -112 15 -158 25 -16 4 -33 24 -52 64 -17 32 -37 61
-46 65 -9 3 -91 6 -181 6 l-164 0 0 340 0 340 385 0 385 0 0 -58z m746 -19
c-29 -339 -188 -685 -432 -942 -97 -102 -257 -231 -353 -284 l-50 -28 -32 62
-31 62 42 81 c24 45 46 85 50 89 4 5 39 -1 77 -12 97 -29 136 -28 162 5 26 33
27 64 2 96 -19 23 -39 32 -138 57 l-41 11 28 83 c65 191 114 456 127 680 l6
117 295 0 295 0 -7 -77z m-3276 -503 c0 -334 4 -350 88 -350 20 0 51 24 129
102 l103 103 103 -103 c78 -78 109 -102 129 -102 84 0 88 16 88 350 l0 280
345 0 345 0 0 -515 0 -515 -449 0 c-308 0 -458 -4 -481 -11 -58 -21 -71 -111
-20 -139 12 -6 200 -10 484 -10 l466 0 0 -40 0 -40 -219 0 c-206 0 -220 -1
-245 -21 -32 -25 -35 -75 -7 -110 19 -24 21 -24 245 -27 l226 -3 0 -130 0
-129 -519 0 -520 0 -26 58 c-66 144 -219 229 -367 203 -124 -22 -224 -97 -268
-204 l-24 -57 -148 0 -148 0 0 845 0 845 345 0 345 0 0 -280z m480 103 l0
-176 -64 61 c-51 49 -71 62 -96 62 -25 0 -45 -13 -96 -62 l-64 -61 0 176 0
177 160 0 160 0 0 -177z m1695 -673 l155 -310 0 -265 0 -265 -43 0 c-43 0 -43
0 -67 57 -44 107 -144 182 -268 204 -148 26 -301 -59 -367 -203 -25 -54 -29
-58 -61 -58 l-34 0 0 575 0 575 265 0 265 0 155 -310z m133 148 c-6 -18 -25
-20 -31 -3 -5 10 0 15 14 15 12 0 19 -5 17 -12z m-2313 -889 c87 -24 139 -93
138 -184 -1 -184 -237 -252 -343 -99 -65 96 -15 240 96 279 48 17 59 18 109 4z
m1957 1 c101 -28 164 -150 127 -247 -24 -64 -109 -122 -179 -123 -52 0 -120
38 -154 87 -70 101 -16 247 104 281 47 14 59 14 102 2z"
      />
      <path
        d="M2570 1690 c-19 -19 -20 -33 -20 -280 0 -247 1 -261 20 -280 19 -19
33 -20 344 -20 l325 0 20 26 c12 15 21 35 21 45 0 30 -247 516 -265 523 -9 3
-109 6 -221 6 -191 0 -205 -1 -224 -20z m430 -280 l70 -140 -180 0 -180 0 0
140 0 140 110 0 110 0 70 -140z"
      />
      <path
        d="M920 679 c-90 -36 -129 -153 -77 -230 38 -57 84 -81 144 -77 163 13
207 226 61 297 -47 23 -88 26 -128 10z"
      />
      <path
        d="M2860 668 c-48 -25 -90 -89 -90 -138 0 -36 40 -110 72 -134 16 -11
49 -21 80 -24 44 -3 59 0 88 20 101 69 109 192 17 262 -49 38 -111 43 -167 14z"
      />
    </g>
  </svg>
);

export const returnsInfoIcon = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="10%"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#616365"
      stroke="none"
    >
      <path
        d="M3585 4901 c-84 -21 -148 -84 -165 -163 -5 -27 -10 -167 -10 -313 l0
-264 -1042 -4 c-1138 -4 -1070 0 -1254 -62 -448 -150 -759 -560 -790 -1042 -6
-87 -4 -105 14 -146 27 -61 75 -104 136 -122 59 -18 261 -20 321 -4 98 26 165
113 165 213 0 72 24 166 61 238 41 82 145 186 227 227 124 62 90 61 1175 61
l987 0 0 -265 c0 -146 5 -286 10 -313 20 -91 107 -164 199 -165 100 -1 94 -6
569 467 287 285 454 459 473 491 22 39 29 62 29 105 0 43 -7 66 -29 105 -44
75 -905 929 -951 943 -56 17 -93 21 -125 13z"
      />
      <path
        d="M1439 2336 c-26 -7 -64 -26 -85 -43 -22 -18 -229 -222 -460 -455
-274 -275 -429 -438 -443 -465 -31 -63 -28 -135 8 -198 19 -32 186 -206 473
-491 475 -473 469 -468 569 -467 92 1 179 74 199 165 5 27 10 167 10 313 l0
264 1043 4 c1019 3 1044 4 1127 24 526 130 882 550 916 1082 6 85 4 103 -14
144 -27 61 -75 104 -136 122 -59 18 -261 20 -321 4 -98 -26 -165 -113 -165
-213 -1 -235 -179 -456 -412 -511 -53 -12 -215 -15 -1050 -15 l-988 0 0 265
c0 146 -5 286 -10 313 -25 116 -146 189 -261 158z"
      />
    </g>
  </svg>
);

export const deliveryCostsIcon = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="10%"
    height="30"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#616365"
      stroke="none"
    >
      <path
        d="M970 3903 c-20 -7 -59 -44 -73 -68 -7 -12 -14 -85 -17 -175 l-5 -155
-195 -6 c-107 -3 -196 -6 -198 -7 -2 -1 -9 -16 -16 -34 -19 -44 -7 -80 35
-101 31 -16 73 -17 537 -15 l504 3 24 28 c29 34 31 66 3 101 l-20 26 -255 0
-254 0 0 125 0 125 1325 0 1325 0 -2 -1042 -3 -1043 -583 -3 c-461 -2 -583 0
-587 10 -46 134 -88 198 -170 260 -130 99 -316 114 -466 37 -91 -46 -174 -147
-211 -254 l-17 -50 -305 -3 -306 -2 0 230 0 230 135 0 c122 0 137 2 155 20 30
30 30 83 -1 115 -19 20 -33 20 -560 20 l-541 0 -24 -28 c-29 -34 -31 -66 -3
-101 l20 -26 330 0 329 0 0 -284 c0 -264 1 -285 19 -307 l19 -24 368 -5 367
-5 12 -40 c46 -156 183 -276 350 -306 201 -37 426 100 483 293 l17 58 726 0
725 0 13 -50 c28 -108 121 -214 234 -265 236 -109 510 9 596 255 l19 55 94 5
c104 6 135 19 169 73 19 30 20 47 17 327 -3 290 -3 296 -28 355 -14 33 -126
240 -248 460 -234 421 -264 464 -338 484 -24 7 -156 11 -341 11 l-302 0 -3
303 c-3 298 -3 302 -26 335 -48 67 59 62 -1459 61 -758 0 -1385 -3 -1393 -6z
m3496 -872 c33 -38 455 -808 469 -855 11 -38 15 -107 15 -283 l0 -234 -61 3
-60 3 -17 50 c-76 224 -302 348 -527 290 -145 -38 -268 -157 -310 -300 -12
-40 -12 -40 -69 -43 l-56 -3 0 696 0 695 300 0 c281 0 301 -1 316 -19z m-2297
-1187 c62 -18 132 -78 163 -138 29 -56 35 -150 14 -213 -22 -66 -76 -127 -140
-160 -62 -32 -167 -36 -229 -9 -58 25 -122 90 -147 148 -27 64 -25 171 5 233
42 85 147 153 241 154 22 1 64 -6 93 -15z m2324 -4 c190 -71 239 -327 89 -462
-58 -52 -105 -71 -182 -71 -155 -1 -268 104 -278 257 -5 89 19 153 82 215 78
77 186 100 289 61z"
      />
      <path
        d="M925 3168 c-43 -25 -44 -33 -45 -285 l0 -243 -120 0 c-115 0 -122 -1
-145 -25 -33 -32 -33 -78 0 -110 l24 -25 734 0 c728 0 735 0 761 21 37 29 37
89 0 118 -26 21 -36 21 -560 21 l-534 0 0 241 0 241 -29 29 c-31 31 -54 35
-86 17z"
      />
      <path
        d="M22 3044 c-34 -24 -31 -95 5 -124 26 -20 34 -21 331 -18 l304 3 19
24 c26 32 25 82 -4 109 -23 22 -29 22 -328 22 -259 0 -308 -2 -327 -16z"
      />
    </g>
  </svg>
);
